import script from "./MasterTestManager.vue?vue&type=script&setup=true&lang=js"
export * from "./MasterTestManager.vue?vue&type=script&setup=true&lang=js"

import "./MasterTestManager.vue?vue&type=style&index=0&id=a5931052&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5931052"]])

export default __exports__